import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { autoComplete } from "../../services/pappers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import autoCompleteZipCode from "../../services/zipCodes";
import { userNewPasswordValidationSchema } from "../../validationSchemas/utilisateur.validation";

const ValidatedNewPasswordForm = props => {
  return (
    <Formik
      initialValues={{}}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};

        const passwordRegex = /(?=.*[0-9])/;
        if (!values.oldPassword) {
          errors.oldPassword = "Ancien mot de passe requis";
        } else if (values.oldPassword.length < 2) {
          errors.oldPassword =
            "Votre mot de passe doit faire au moins 2 caractères de long.";
        } else if (!passwordRegex.test(values.oldPassword)) {
          errors.oldPassword =
            "Votre mot de passe doit contenir au moins un caractère spécial.";
        }

        if (!values.newPassword) {
          errors.newPassword = "Veuillez spécifier un mot de passe";
        } else if (values.newPassword.length < 2) {
          errors.newPassword =
            "Votre mot de passe doit faire au moins 2 caractères de long.";
        } else if (!passwordRegex.test(values.newPassword)) {
          errors.newPassword =
            "Votre mot de passe doit contenir au moins un caractère spécial.";
        }

        if (values.newPassword !== values.passwordConfirmation) {
          errors.passwordConfirmation =
            "Les mots de passe doivent être identiques";
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={userNewPasswordValidationSchema}
    >
      {props => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        return (
          <form name="register" onSubmit={handleSubmit}>
            <Row>
              <Col xs={6}>
                <label htmlFor="password" className="form-label">
                  Mot de passe actuel
                </label>{" "}
                <span className="text-muted"></span>
                <input
                  name="oldPassword"
                  type="password"
                  className={`form-control ${errors.oldPassword &&
                    touched.oldPassword &&
                    "is-invalid"}`}
                  value={values.oldPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.oldPassword && touched.oldPassword && (
                  <div className="invalid-feedback">{errors.oldPassword}</div>
                )}
              </Col>
              <Col xs={6}></Col>
              <Col xs={6}>
                <label htmlFor="newPassword" className="form-label">
                  Nouveau mot de passe (confirmation)
                </label>
                <input
                  name="newPassword"
                  type="password"
                  className={`form-control ${errors.newPassword &&
                    touched.newPassword &&
                    "is-invalid"}`}
                  value={values.newPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.newPassword && touched.newPassword && (
                  <div className="invalid-feedback">{errors.newPassword}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="passwordConfirmation" className="form-label">
                  Nouveau mot de passe (confirmation)
                </label>
                <input
                  name="passwordConfirmation"
                  type="password"
                  className={`form-control ${errors.passwordConfirmation &&
                    touched.passwordConfirmation &&
                    "is-invalid"}`}
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.passwordConfirmation &&
                  touched.passwordConfirmation && (
                    <div className="invalid-feedback">
                      {errors.passwordConfirmation}
                    </div>
                  )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Mettre à jour
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default ValidatedNewPasswordForm;
